<template>
  <tbody>
    <tr class="m-table__row">
      <td class="m-table__col" :data-table-col-label="$t('business-list-business-label')">
        <div class="business-list__name">
          <div class="business-list__picture" v-if="business.ImageUri">
            <img class="business-list__picture-image" :src="business.ImageUri" :alt="business.Name" />
          </div>
          <a :href="business.Url" class="business-list__name-text">{{ business.Name }}</a>
          <span v-if="!isPublish" class="business-list__name-flag">{{ $t('business-publish-status-draft') }}</span>
        </div>
      </td>
      <td class="m-table__col" :data-table-col-label="$t('business-list-entrepeneurs-label')">
        <span v-for="id in entrepreneurIds" :key="id">{{ getEntrepreneurName(id) }}<br /></span>
      </td>
      <td class="m-table__col" :data-table-col-label="$t('business-list-isRegistered-label')">
        <span v-if="isRegistered">{{ $t('business-registered-status') }}</span>
        <span v-else>{{ $t('business-notregistered-status') }}</span>
      </td>
      <td class="m-table__col" :data-table-col-label="$t('business-list-isPublish-label')">
        <span v-if="isPublish && isRegistered">{{ $t('business-publish-status') }}</span>
        <span v-else-if="isPublish && !isRegistered">{{ $t('business-publish-but-not-registered-status') }}</span>
        <span v-else>{{ $t('business-notpublish-status') }}</span>
      </td>
      <td class="m-table__col m-table__col--right">
        <button class="a-btn-primary a-btn-primary--small" v-if="isPublish && isRegistered" @click="editBusiness" type="button">{{ $t('business-edit-btn') }}</button>
        <button class="a-btn-primary a-btn-primary--small" v-else @click="editBusiness" type="button">{{ $t('business-complete-btn') }}</button>
        <button class="a-btn-primary a-btn-primary--small" style="margin-left: 10px; margin-top: 10px;" v-if="!isRegistered" @click="registerBusiness" type="button">
          {{ $t('business-register-btn') }}
        </button>
      </td>
    </tr>
  </tbody>
</template>

<script>
import router from '@/router'
import { URL_EDIT_BUSINESS } from '@/consts/urls'
import SnipcartService from '@/services/snipcart'

export default {
  props: {
    business: {
      type: Object,
      required: true
    },
    entrepreneurs: {
      type: Array,
      required: true
    }
  },
  computed: {
    isRegistered: function() {
      return this.business.IsRegistered
    },
    isPublish: function() {
      return this.business.IsPublish
    },
    entrepreneurIds: function() {
      return this.business.EntrepreneurIds
    }
  },
  methods: {
    editBusiness: function() {
      router.push({
        name: URL_EDIT_BUSINESS,
        params: { id: this.business.Id }
      })
    },
    registerBusiness: function() {
      SnipcartService.addBusinessToCart(this.business.Id, this.business.Name, false)
    },
    getEntrepreneurName: function(id) {
      return this.entrepreneurs.find(x => x.Id === id).Name
    }
  }
}
</script>

<style lang="scss">
.business-list {
  &__name {
    align-items: center;
    display: flex;

    &-text {
      color: currentColor;
    }

    &-flag {
      color: #ea5244;
      padding-left: 10px;
      font-style: italic;
      font-size: 18px;
    }
  }

  &__picture {
    border-radius: 50%;
    height: 60px;
    margin-right: 35px;
    overflow: hidden;
    position: relative;
    width: 60px;

    &-image {
      display: block;
      left: 50%;
      max-height: 60px;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
